import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
declare var $: any;

@Injectable()
export class NickNameModalService {

  constructor() { }

  private nickNameModal = new BehaviorSubject(null);
  nickNameObservable = this.nickNameModal.asObservable();

  private nickNameDataUpdated = new BehaviorSubject(null);
  nickNameDataUpdatedObservable = this.nickNameDataUpdated.asObservable();

  openNickNameModal(): void {
    this.nickNameModal.next(true);
    $("#nickNameModal").modal('show')
  }

  close(): void {
    this.nickNameModal.next(false);
    $(".modal-backdrop").hide();
    $(".modal-open").css('overflow', 'auto');
    $("#nickNameModal").modal('hide');
  }

  nickNameUpdatedStatus(status: boolean) {
    if (status) {
      this.nickNameDataUpdated.next(true);
    } else {
      this.nickNameDataUpdated.next(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/nick-name-modal.service.ts